import { Component, OnInit, ViewChild } from '@angular/core';
import { AppService, CoreProxyService } from 'common-cloudstudio';

@Component({
  selector: 'app-map-tabs',
  templateUrl: './map-tabs.component.html',
  styleUrls: ['./map-tabs.component.scss']
})
export class MapTabsComponent implements OnInit {
  maps = [
    {
      name: 'Eventos',
      latitude: 37.7749,
      longitude: -122.4194,
      zoom: 13
    },
    {
      name: 'Consumo',
      latitude: 37.7749,
      longitude: -122.4194,
      zoom: 13
    }
  ];
  activeTab = 1;
  showCustomMap = false;

  constructor(
    public  _appService: AppService,
    private _coreProxyService: CoreProxyService
  ) {}

  ngOnInit(): void {

  }

  onTabChange(tabNumber: number) {
    this.activeTab = tabNumber;
    if (tabNumber === 2 && !this.showCustomMap) {
      this.showCustomMap = true;
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100);
    }
  }
  
}
